// Port of Views.UserDetail.backToUsers with the intended restricted-user branch.
export const backToUsers = (campaignId, currentUser = {}, location = window.location) => {
  if (currentUser.isRestrictedUser === true) {
    location.assign('/home/');
    return;
  }
  if (window.AdminSettingsRouter) {
    window.AdminSettingsRouter.navigate(`/settings/users/${campaignId}`, { trigger: true });
  }
};

export const swapUrlToEdit = (userId) => {
  if (window.Backbone && window.Backbone.history) {
    window.Backbone.history.navigate(`/settings/users/edit/${userId}/`, { trigger: false, replace: true });
  }
};
